import { httpsCallable } from 'firebase/functions';
import { functions } from '../platform/firebase/clients';

export interface RerunTaskReviewerRequest {
  taskId: string;
}

export interface RerunTaskReviewerResult {
  /** Number of LLM comments deleted before the rerun (pending + unaddressed). */
  commentsCleared: number;
  /** Number of LLM comments the rerun produced and wrote. May be 0 — the
   *  reviewer is sparing by default. */
  commentsAdded: number;
  /** Present only for report reviewers (e.g. `slop-rewrite`), which rebuild
   *  the task's AI review report instead of writing comments. */
  reportStatus?: 'complete' | 'failed';
  reportError?: string;
}

// Reviewer calls can take 10–60s on Kimi K3; allow a bit more for cold starts.
const TIMEOUT_MS = 4 * 60 * 1000;

export async function rerunTaskReviewer(
  req: RerunTaskReviewerRequest,
): Promise<RerunTaskReviewerResult> {
  const fn = httpsCallable<RerunTaskReviewerRequest, RerunTaskReviewerResult>(
    functions,
    'rerunTaskReviewer',
    { timeout: TIMEOUT_MS },
  );
  const res = await fn(req);
  return res.data;
}
